import React, { useState } from "react";
import SigmaRichEditor from "../components/SigmaRichEditor";
const parse = require("html-react-parser");

const TestScreen = () => {
  const [content, setcontent] = useState("");

  return (
    <main>
      <>
        <div>
          <SigmaRichEditor setcontent={setcontent} />
        </div>
        <div className="unset-tailwind">{parse(content)}</div>
      </>
    </main>
  );
};

export default TestScreen;
